import React,{useState,useEffect} from 'react'
import { Page, Link,Button,Badge,IndexTable,SkeletonBodyText,Layout,Pagination,Text,Tooltip,Modal,Image,Card,InlineStack,useIndexResourceState} from '@shopify/polaris';
import SearchBar from './common/SearchBar';
import useIsMobile from './useIsMobile'; 
import axios from "axios";
import wrap from "word-wrap";
import defaultInage from '../assets/image.jpg'
import { toast } from 'react-toastify';

const Listing = () => {
  const isMobile = useIsMobile();
  const resourceName = {
    singular: 'product',
    plural: 'products',
  };
  const handleClose = () => setActive(false);
  const [whichPage,setwhichPage] = useState("listings");
  const [products, setProducts] = useState([]);
  const [productNotExists, setProductNotExists] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [firstProductNo, setFirstProductNo] = useState(0);
  const [lastProductNo, setLastProductNo] = useState(0);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [selectedListing, setSelectedListing] = useState([]);
  const [query,setQuery] = useState('Product desc');
  const [active, setActive] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [current_page,setCurrentPage] = useState(0);
  const [page,setPage] = useState(1);
  const [allProductId,setAllProductId] = useState([]);
  const addProductId = (newId) => {
    setAllProductId((prevState) => [...prevState, newId]);
  };
  const handleOpen = (variants) => {
    setSelectedVariants(variants);
    setActive(true);
  };

  const {selectedResources, allResourcesSelected, handleSelectionChange} =
          useIndexResourceState(products);
      const handleAllSelections = (value)=>{
        console.log(selectedResources);
        
      }
      const getBadgeTone = (status) => {
        switch (status.toLowerCase()) {
          case "ebay":
            return "info";
          case "shopify":
            return "success";
          default:
            return "success"; 
        }
      };
const [perPageValue,setPerPageValue] = useState("20");
        useEffect(() => {
          const fetchlinked = async () => {
            try {
                const response = await axios.get(
                        `${process.env.REACT_APP_API_URL}/linked`
                      );
                      if (response.data.total === 0) {
                        setProductNotExists(true);
                      }else{
                        setProductNotExists(false);
          
                      }
      
        
              setTotalPage(response.data.total);
              setFirstProductNo(response.data.from);
              setLastProductNo(response.data.to);
              setCurrentPage(response.data.current_page);
              const result = response.data;
              const formattedProducts = result.data.map((product) => {
                if (product.type === "eb_product") {
                    return {
                        Listing: product,
                        id: product.product_id,
                        title: wrap(product.title, { width: 40 }),
                        status: product.status === "Linked" ? "Shopify" : "Ebay",
                        image: product.main_image,
                        variants: product.eb_product_variants ? product.eb_product_variants.length : 0,
                        variations: product.eb_product_variants
                            ? product.eb_product_variants.map((variant) => ({
                                  title: variant.title || "Default Option",
                                  quantity: variant.quantity,
                                  price: variant.price,
                                  option1: variant.option1val || "-",
                                  option2: variant.option2val || "-",
                                  option3: variant.option3val || "-",
                              }))
                            : [],
                    };
                } else if (product.type === "sh_product") {
                  
                    return {
                        Listing: product,
                        id: product.id,
                        title: wrap(product.title, { width: 40 }),
                        status: product.status === "Linked" ? "Shopify" : "Ebay",
                        image: product.main_image,
                        variants: product.sh_product__variant ? product.sh_product__variant.length : 0,
                        variations: product.sh_product__variant
                            ? product.sh_product__variant.map((variant) => ({
                                  title: variant.title || "Default Option",
                                  quantity: variant.quantity,
                                  price: variant.price,
                                  option1: variant.option1val || "-",
                                  option2: variant.option2val || "-",
                                  option3: variant.option3val || "-",
                              }))
                            : [],
                    };
                }
            });
              setProducts(formattedProducts);
            } catch (error) {
              console.error("Error fetching products:", error);
            }
          };
      
          fetchlinked();
        }, []);
        const handlePerPage = (event) => {
          setPerPageValue(event.target.value);
          
          fetchlinked(query,page,event.target.value)
          console.log(event.target.value); 

        };
        const fetchlinked = async (query=query,page = 1,parPage) => {
          const params = {}; // Initialize an empty params object

          if (query) {
              params.query = query; // Only add 'query' if it's not empty
          }
  
          params.page = page; 
          params.per_page = parPage;
          try {
              const response = await axios.get(
                      `${process.env.REACT_APP_API_URL}/linked`,
                      {params}
                    );
              if (response.data.total === 0) {
                setProductNotExists(true);
              }else{
                setProductNotExists(false);
  
              }
          
            setTotalPage(response.data.total);
            setFirstProductNo(response.data.from);
            setLastProductNo(response.data.to);
            setCurrentPage(response.data.current_page);
            const result = response.data;
            console.log(result.data);
            
            const formattedProducts = Object.values(result.data).map((product) => {
              
              // console.log(product);
              
              if (product.type === "eb_product") {
                
                  return {
                      Listing: product,
                      id: product.product_id,
                      title: wrap(product.title, { width: 40 }),
                      status: product.status === "Linked" ? "Shopify" : "Ebay",
                      image: product.main_image,
                      variants: product.eb_product_variants ? product.eb_product_variants.length : 0,
                      variations: product.eb_product_variants
                          ? product.eb_product_variants.map((variant) => ({
                                title: variant.title || "Default Option",
                                quantity: variant.quantity,
                                price: variant.price,
                                option1: variant.option1val || "-",
                                option2: variant.option2val || "-",
                                option3: variant.option3val || "-",
                            }))
                          : [],
                  };
              } else if (product.type === "sh_product") {
                
                  return {
                      Listing: product,
                      id: product.id,
                      title: wrap(product.title, { width: 40 }),
                      status: product.status === "Linked" ? "Shopify" : "Ebay",
                      image: product.main_image,
                      variants: product.sh_product__variant ? product.sh_product__variant.length : 0,
                      variations: product.sh_product__variant
                          ? product.sh_product__variant.map((variant) => ({
                                title: variant.title || "Default Option",
                                quantity: variant.quantity,
                                price: variant.price,
                                option1: variant.option1val || "-",
                                option2: variant.option2val || "-",
                                option3: variant.option3val || "-",
                            }))
                          : [],
                  };
              }
          });
            setProducts(formattedProducts);
          } catch (error) {
            console.error("Error fetching products:", error);
          }
        };

        const handleUnlinkProduct = async (id) => {
          try {
            const response = await axios.put( `${process.env.REACT_APP_API_URL}/unlinkProducts`,
              {id:id});
              toast.success(response.data.message);
              fetchlinked(query);

          } catch (error) {
            console.log(error);
            
          }
        }

        
               const rowMarkup = products.map(
                        (
                          {id, title, status, image,variants,variations,Listing},
                          index,
                        ) => (
                          <IndexTable.Row
                            id={id}
                            key={id}
                            selected={selectedResources.includes(id)}
                            position={index}
                            rowType={"subheader"}
                          >
                            <IndexTable.Cell>
                                   {image ? (
                                        <img
                                                src={image}
                                                alt={title}
                                                width="50"
                                                height="50"
                                        />
                                ) : (
                                        <Image
                                                src={defaultInage}
                                                width="50"
                                                height="50"
                                        />
                                )}
                            </IndexTable.Cell>
                            <IndexTable.Cell width="500px">
                                  
                                <div style={{ display: "ruby-text", alignItems: "center", gap: "4px", flexWrap: "nowrap" }}>
                                        <Text  monochrome style={{ display: "flex", alignItems: "center", gap: "4px", whiteSpace: "pre-line" }}>
                                                <span>
                                                        {title.split("\n").map((line, idx) => (
                                                                <React.Fragment key={idx}>
                                                                {line}
                                                                {idx !== title.split("\n").length - 1 && <br />}
                                                                </React.Fragment>
                                                        ))}
                                                </span>
                                                {/* <Icon source={EditIcon} tone="base" /> */}
                                        </Text>
                                </div>      
                                {isMobile && (
                                                <>
                                          
                                
                                                  <Text as="p">Variants: {variants}</Text>
                                                <Badge tone={getBadgeTone(status)}>{status}</Badge>
                                                  <IndexTable.Cell>
                                                  <Button id="Import_button"onClick={() => handleUnlinkProduct(id)} >
                                                       Unlinked
                                                   </Button>
                                                  </IndexTable.Cell>
                                                </>
                                              )}
                                </IndexTable.Cell>
                             { !isMobile && (
                                <>
                                     <IndexTable.Cell > <Badge tone={getBadgeTone(status)}>{status}</Badge></IndexTable.Cell>
                                     <IndexTable.Cell>
                                      <Tooltip content="Variants">

                                         <Button onClick={() => handleOpen(variations)} >
                                      <Text>{variants}</Text>
                                         
                                         </Button>
                                      </Tooltip>
                                      
                                     </IndexTable.Cell>
                                     <IndexTable.Cell>
                                        { status === 'Ebay' ? (
                                            <Button  disabled id="Ebay_unlinked"onClick={() => handleUnlinkProduct(id)} >
                                                    UnLinked
                                            </Button>
                                        ):(
                                          <Button id="Import_button"onClick={() => handleUnlinkProduct(id)} >
                                                  UnLinked
                                          </Button>
                                        )}
                                            
                                     </IndexTable.Cell>
                                     </>
                             )}
                          </IndexTable.Row>
                        ),
                      );
  return (
          <Page  fullWidth
            title="Listing"
            className="product-list"
          >
          <div style={{ width: "100%", marginRight: "20px" ,marginBottom: "40px" }}>

             <Layout >
                    <Layout.Section>
                     
                         <Card>
                         <InlineStack>
                            <div style={{ width: "100%", marginRight: "20px" ,marginBottom: "20px" }}>
                            <SearchBar fetchproduct={fetchlinked} whichPage={whichPage}  />

                            </div>
                      
                            </InlineStack>
                         </Card>
                          { !products || products.length === 0 ? (
                                             <Card>
                                           
                                             <SkeletonBodyText lines={1} />
                                             <SkeletonBodyText lines={3} />
                                             <SkeletonBodyText lines={3} />
                                             <SkeletonBodyText lines={3} />
                                             <SkeletonBodyText lines={3} />
                                             <SkeletonBodyText lines={3} />
                                             <SkeletonBodyText lines={3} />   
                                             <SkeletonBodyText lines={3} />
                                             <SkeletonBodyText lines={3} />
                                         
                                 
                                             </Card>
                                           ) :(
                                            <Card>
                                            <IndexTable
                                            resourceName={resourceName}
                                            itemCount={products.length}
                                            onChange={handleAllSelections}
                                            selectedItemsCount={allResourcesSelected ? 'All' : selectedResources.length}
                                            onSelectionChange={handleSelectionChange}
                                                  headings={[
                                                  {title: 'Image'},
                                                  {title: 'Title'},
                                                  {title: 'Source'},
                                                  {title: 'Varinats'},
                                                  {title: 'Action'},
                                                  ]}
                                                  >
                                                  {rowMarkup}
                                                   <Modal open={active} onClose={handleClose} title="Product Variation List" primaryAction={{ content: "Close", onAction: handleClose }}>
                                                                  <Modal.Section>
                                                                    {selectedVariants.length > 0 ? (
                                                                      <table className="Polaris-Table variant-table">
                                                                        <thead>
                                                                          <tr>
                                                                            <th>Title</th>
                                                                            <th>Sku</th>
                                                                            <th>Quantity</th>
                                                                            <th>Price</th>
                                                                            <th>Option1</th>
                                                                            <th>Option2</th>
                                                                            <th>Option3</th>
                                                                          </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                          {selectedVariants.map((variant, index) => (
                                                                            <tr key={index}>
                                                                              <td>{variant.title}</td>
                                                                              <td>{variant.ebayitemid}</td>
                                                                              <td>{variant.quantity}</td>
                                                                              <td>${variant.price}</td>
                                                                              <td>{variant.option1}</td>
                                                                              <td>{variant.option2}</td>
                                                                              <td>{variant.option3}</td>
                                                                            </tr>
                                                                          ))}
                                                                        </tbody>
                                                                      </table>
                                                    
                                                                    ) : (
                                                                      <Text>No Variants Available</Text>
                                                                    )}
                                                                  </Modal.Section>
                                                                          </Modal>
                                           </IndexTable>
                                        </Card>
                                           )}
                      
                               <div>
                         
                                            <div style={{ width: "90%", marginRight: "20px" ,marginBottom: "20px",float:"left" }}>          
                                                         <Pagination
                                                            onPrevious={() => {
                                                              fetchlinked(query,current_page-1,perPageValue);
                                                            }}
                                                            onNext={() => {
                                                              fetchlinked(query,current_page+1,perPageValue);
                                                            }}
                                                            hasPrevious
                                                            type="table"
                                                            hasNext
                                                            label={`${firstProductNo}-${lastProductNo} of ${totalPage} products`}
                                                          />
                                           </div>
                                                      <select
                                                                name="selectedFruit"
                                                                style={{
                                                                height: "30px",
                                                                marginTop: "5px",
                                                                background: "#ddddddec",
                                                                border: "none",
                                                                }}
                                                                className="SelectPerPage"
                                                                onChange={handlePerPage}
                                                                value={perPageValue}
                                                                >
                                                                <option value="20">20</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                        </select>
                                                  </div>
                         </Layout.Section>
             </Layout>

             </div>
          </Page>
  )
}

export default Listing